module.exports = __webpack_public_path__ + "static/DHCM3-0847a908b75285a76ed2c32988cdbb91.png";